import { createSlice } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
// import { isEmpty } from 'lodash';
import { API } from 'api';

const initialState = {
	statesWithCites: {},
};

export const clientContractSlice = createSlice({
	name: 'clientContractState',
	initialState,
	reducers: {},
});

export const getClientContractList =
	({ search_type = '', limit = 10, offset = 10, currentPage, ...rest }) =>
	async () => {
		console.log('limit', limit);
		console.log('offset', offset);

		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				offset,
				limit,
				filter_by: {},
				...rest,
			},
		};

		return API.common(CREDENTIALS).then((response) => response);
	};

export const addClient =
	({ req_data, setErrors }) =>
	async () => {
		console.log('setErrors', setErrors);

		const data = {
			create_type: 'client',
			data: {
				password: req_data?.data?.password,
				client_info: req_data?.data,
			},
		};

		console.log(data);

		const CREDENTIALS = {
			url: '/create',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);

		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			toaster.success('Client added successfully');
			return res;
		});
	};

export const updateClient =
	({ req_data, setErrors }) =>
	async () => {
		console.log(req_data);
		let data = {};
		data = {
			update_type: 'client',
			id: req_data?.id,
			data: {
				...req_data,
			},
		};
		console.log(data);
		const CREDENTIALS = {
			url: '/update',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);
		return API.common(CREDENTIALS)
			.then((res) => {
				console.log(res);
				toaster.success('Successfull');
				return res;
			})
			.catch((error) => {
				console.log(error.message);
				toaster.error(error.message);
			});
	};

export default clientContractSlice.reducer;
